module.exports = __webpack_public_path__ + "img/img-yd-app-mobile.aa690c7.svg";